const _UTILS = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });  
  }
};

function readMore() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}

if (!customElements.get('product-images-gallery')) {
  customElements.define('product-images-gallery', class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        this.$gallery = this.querySelector('.product_gallery');
        this.flickity = Flickity.data(this.$gallery);
        this.flickity.on('change', this.OnGalleryChange.bind(this));
      });
    }

    OnGalleryChange(index) {
      let $currentSlide = this.$gallery.querySelector('.gallery-cell.is-selected');
      let variant = JSON.parse($currentSlide.dataset.variant);
      // console.log(variant);
      if (!variant) return;
      this.UpdateVariant(variant);
    }
    
    UpdateVariant(variant) {
      let $product = this.closest('.product_section');
      if (!$product) return;
      variant.options.forEach((optionValue, optionIndex) => {
        let $select = $product.querySelector(`.single-option-selector[data-option="option${optionIndex+1}"]`);
        if ($select.value == optionValue) return;
        $select.value = optionValue;
        $select.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
  });
}